import { createVar } from '~/theme';

export const paddingInline = createVar('header-paddingInline');
export const headerHeight = createVar('header-height');
export const logoHeight = createVar('header-logoHeight');
export const navHeight = createVar('header-navHeight');
